export const primaryColor: string = "#008aff";
export const primaryLightColor: string = "#4db8ff";
export const primaryVisitedColor: string = primaryColor;
export const secondaryColor: string = "#ff0020";
export const lightBlue: string = "#e6f5ff";

export const COLORS = {
  PRIMARY: primaryColor,
  PRIMARY_LIGHT: primaryLightColor,
  PRIMARY_VISITED: primaryVisitedColor,
  SECONDARY: secondaryColor,
  LIGHT_BLUE: lightBlue,
};
